import { Box, Button, Chip, Grid2, Typography } from "@mui/material";
import React from "react";
import Teacher from "Assets/Images/Teacher.png";
import { ReactComponent as CalendarIcon } from "Assets/Icons/Home/CalendarIcon.svg";
import { ReactComponent as ClockIcon } from "Assets/Icons/Home/ClockIcon.svg";
import { ReactComponent as PlayIcon } from "Assets/Icons/Home/PlayIcon.svg";
import { ReactComponent as CoinIcon } from "Assets/Icons/Home/CoinIcon.svg";
import { ReactComponent as StreakIcon } from "Assets/Icons/Home/StreakIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";

const styles = (theme) => ({
  display: "flex",
  gap: "15px",
  "&>div": {
    width: "100%",
    display: "flex",
    gap: "15px",
    flexDirection: "column",
  },
  "& .teacherImg": {
    maxWidth: "220px",
    maxHeight: "240px",
    height: "100%",
    width: "100%",
    objectFit: "cover",
  },
  "& .lectureHead": {
    display: "flex",
    justifyContent: "space-between",
  },
  "& .lectureBody": {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    "& .time": {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      "&>p": {
        display: "flex",
        alignItems: "center",
        gap: "5px",
      },
    },
  },
  "& .lectureFooter": {
    display: "flex",
    justifyContent: "space-between",
    "& .earnings": {
      display: "flex",
      alignItems: "center",
      gap: "5px",
      marginTop: "5px",
    },
  },
});

const Lecture = () => {
  return (
    <Grid2 sx={styles}>
      <img className="teacherImg" src={Teacher} />
      <Grid2>
        <Grid2 className="lectureHead">
          <Box gap={"5px"} display={"flex"} flexDirection={"column"}>
            <Typography variant="title" fontWeight={500}>
              Walmart : Confidence Interval and CLT
              <Chip
                sx={{ marginLeft: "10px" }}
                outlined
                color="error"
                variant="outlined"
                label="Live Ended"
              />
            </Typography>
            <Typography color="secondary.light">
              Practice for real world technical interview by completing this
              business case
            </Typography>
          </Box>
          <Box>
            <Typography variant="body2">Deadline In</Typography>
            <Typography fontWeight={500} variant="title">
              05d : 02h : 12m : 10s
            </Typography>
          </Box>
        </Grid2>
        <Grid2 className="lectureBody">
          <Box className="time">
            <Typography minWidth={"50px"} fontWeight={500}>
              Started
            </Typography>
            <Typography>
              <PrimaryIcon icon={CalendarIcon} />
              Sat, 26 Oct
            </Typography>
            <Typography>
              <PrimaryIcon icon={ClockIcon} />
              09:00 pm
            </Typography>
          </Box>
          <Box className="time">
            <Typography minWidth={"50px"} fontWeight={500}>
              End
            </Typography>
            <Typography>
              <PrimaryIcon icon={CalendarIcon} />
              Sat, 26 Oct
            </Typography>
            <Typography>
              <PrimaryIcon icon={ClockIcon} />
              09:00 pm
            </Typography>
          </Box>
          {true ? (
            <Box className="notes">
              <Typography fontWeight={500}>Lecture Notes</Typography>
              <Box mt={"8px"} display={"flex"} gap="10px" flexWrap={"wrap"}>
                {[...Array(3)].map((item, i) => {
                  return (
                    <Chip
                      key={i}
                      outlined
                      color="error"
                      variant="outlined"
                      label={<> Annova-notes.pdf </>}
                    />
                  );
                })}
              </Box>
            </Box>
          ) : (
            <Typography variant="body2" color="secondary.light">
              Crossing deadline will result in maximum deduction of 70 % marks
              on each question
            </Typography>
          )}
        </Grid2>
        <Grid2 className="lectureFooter">
          {true ? (
            <Box display={"flex"} gap="10px" alignItems={"center"}>
              <Button
                variant="contained"
                color="error"
                startIcon={<PrimaryIcon icon={PlayIcon} />}
              >
                Watch Recording
              </Button>
              <Typography>20% learners have watched this</Typography>
            </Box>
          ) : (
            <Box display={"flex"} gap="10px" alignItems={"center"}>
              <Button variant="contained" color="success">
                Solve
              </Button>
              <Button variant="outlined" color="secondary">
                View All Business Case Studies
              </Button>
            </Box>
          )}
          <Box>
            <Typography>Watch recording to earn</Typography>
            <Typography className="earnings">
              <PrimaryIcon icon={CoinIcon} fill={false} />
              3 coins
              <PrimaryIcon icon={StreakIcon} fill={false} />1 streak
            </Typography>
          </Box>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default Lecture;
